import { Component, Input } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { findLastIndex } from 'lodash';
import { BehaviorSubject, combineLatest, map } from 'rxjs';

import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { LocationType } from '../../../global.constants';
import { SharedModule } from '../../../shared/shared.module';
import {
  jobToolFeature,
} from '../../job-tool.reducer';
import { overviewLocationsFeature } from '../overview-locations/overview-locations.feature';
import { selectOrderedLocations } from '../overview-locations/overview-locations.selectors';

import { TimeTravelActions } from './time-travel.actions';

@Component({
  selector: 'app-travel-time',
  standalone: true,
  imports: [
    FreyaCommonModule,
    SharedModule
  ],
  templateUrl: './travel-time.component.html',
  styleUrl: './travel-time.component.scss'
})
export class TravelTimeComponent {

  @Input({ required: true }) label!: string;

  private _route$ = new BehaviorSubject<{ start: LocationType; end: LocationType } | null>(null);

  @Input({ required: true }) set route(value: { start: LocationType; end: LocationType }) {
    this._route$.next(value);
  }

  viewModel$ = combineLatest([
    this._route$,
    this.store.select(createSelector(
      selectOrderedLocations,
      overviewLocationsFeature.selectCalculateDistancesOutput,
      jobToolFeature.selectDistancesLoading,
      (orderedLocations, { distances, distanceUnits }, distancesLoading) => ({
        orderedLocations,
        distances,
        distanceUnits,
        distancesLoading,
      })
    )),
  ]).pipe(
    map(([ route, { orderedLocations, distances, distanceUnits, distancesLoading } ]) => {

      let estimatedTime = 0;
      let distance = 0;

      if (!route) {
        return {
          estimatedTime,
          distance,
          distanceUnits,
          locationsMissing: true,
        }
      }

      const startIndex = orderedLocations.findIndex((loc) => loc.locationType === route.start);
      const endIndex = findLastIndex(orderedLocations, ((loc) => loc.locationType === route.end));

      if (startIndex < 0 || endIndex < 0 || startIndex > endIndex || !distances.length) {
        return {
          estimatedTime,
          distance,
          distanceUnits,
          locationsMissing: true,
        }
      }

      for (let i = startIndex; i < endIndex; i++) {
        const routeDistance = distances[i];
        estimatedTime += routeDistance?.estimatedTime ?? 0;
        distance += routeDistance?.distance ?? 0;
      }

      return {
        estimatedTime,
        distance,
        distanceUnits,
        distancesLoading,
        locationsMissing: false,
      }
    })
  );

  actions = TimeTravelActions;

  constructor(
    public store: Store,
  ) {
  }

}
